// wyvio — Identité de marque centralisée.
//
// Tout changement de nom, slogan, palette ou logo passe par ce seul fichier.
// Les composants ne référencent JAMAIS une chaîne "wyvio" en dur — ils
// importent depuis `@/branding`.

export const brand = {
  appName: "wyvio",
  appNameLower: "wyvio",
  slogan: "Le suivi intelligent de vos ventes automobiles",
  sloganShort: "Le suivi intelligent de vos ventes",
  domain: "wyvio.app",
  // Signature utilisée dans les emails et footers
  productSignature: "wyvio",
  // Émetteur email : "{Nom agence} via wyvio"
  emailSenderSuffix: "via wyvio",
};

export const palette = {
  ink: "#111111",         // fond noir premium
  inkSoft: "#1F2937",     // dark hover
  paper: "#FFFFFF",
  bg: "#F7F8FA",          // background layout
  border: "#EEF2F5",
  muted: "#6B7280",
  primary: "#C8FF2F",     // accent officiel wyvio — vert lime
  primarySoft: "#D9FFE8",
  danger: "#EF4444",
  success: "#22C55E",
  warning: "#F59E0B",
  info: "#3B82F6",
};

export const typography = {
  // Sora — rounded geometric sans-serif (wordmark + UI)
  sans: `"Sora", -apple-system, BlinkMacSystemFont, "SF Pro Text", "Segoe UI", Roboto, "Helvetica Neue", sans-serif`,
  mono: `"SF Mono", Menlo, Consolas, monospace`,
};

export const meta = {
  title: "wyvio — Le suivi intelligent de vos ventes automobiles",
  description:
    "wyvio est la plateforme SaaS premium qui connecte agences et clients " +
    "pour un suivi transparent de chaque vente automobile, de la réservation à la remise du CPI.",
  themeColor: palette.ink,
  keywords: ["wyvio", "automobile", "suivi commande", "concession", "SaaS", "CPI", "livraison véhicule"],
};

export const openGraph = {
  title: meta.title,
  description: meta.description,
  siteName: brand.appName,
  type: "website",
};

// Alias : compat legacy des imports historiques `AGENCY.name` déprécié.
// Ne PAS utiliser directement dans les nouveaux composants.
export default brand;
